import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export async function fetchEvents(params = {}) {
  const { data } = await api.get("/events", { params });
  return data;
}

export async function fetchRegions() {
  const { data } = await api.get("/meta/regions");
  return data.regions;
}

export async function fetchCountries() {
  const { data } = await api.get("/meta/countries");
  return data.countries;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Něco se nepovedlo. Zkus to prosím znovu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Format any axios-style error to a friendly Czech message.
 * Handles: network errors (server asleep / offline), 4xx, 5xx, timeouts.
 */
export function friendlyError(err) {
  // No response → network error or server asleep
  if (!err?.response) {
    const code = err?.code || "";
    if (code === "ECONNABORTED" || /timeout/i.test(err?.message || "")) {
      return "Server odpovídá pomalu. Zkus to za chvíli.";
    }
    return 'Server zrovna spí 💤 Klikni dole vpravo na "Wake up servers" a počkej ~30 vteřin.';
  }
  const status = err.response.status;
  if (status === 401) return "Tvoje přihlášení vypršelo. Otevři novou záložku a přihlas se znovu (rozepsaný formulář se neztratil — je uložený).";
  if (status === 403) return formatApiErrorDetail(err.response.data?.detail) || "Na tohle nemáš oprávnění.";
  if (status === 404) return "Tahle stránka nebo akce už neexistuje.";
  if (status === 422) return formatApiErrorDetail(err.response.data?.detail) || "Některá pole nejsou vyplněná správně.";
  if (status >= 500 && status < 600) return 'Server se právě probouzí nebo má potíže. Klikni dole vpravo na "Wake up servers" nebo zkus znovu za chvíli.';
  return formatApiErrorDetail(err.response.data?.detail) || `Chyba ${status}. Zkus to prosím znovu.`;
}
